import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
// LEVEL
const LevelListPage = lazy(() => import('src/pages/dashboard/level/list'));
const LevelCreatePage = lazy(() => import('src/pages/dashboard/level/new'));
const LevelEditPage = lazy(() => import('src/pages/dashboard/level/edit'));

// QUEST
const QuestListPage = lazy(() => import('src/pages/dashboard/quest/list'));
const QuestCreatePage = lazy(() => import('src/pages/dashboard/quest/new'));
const QuestEditPage = lazy(() => import('src/pages/dashboard/quest/edit'));

// GAMES
const GamesListPage = lazy(() => import('src/pages/dashboard/games/list'));
const GamesCreatePage = lazy(() => import('src/pages/dashboard/games/new'));
const GamesEditPage = lazy(() => import('src/pages/dashboard/games/edit'));

// VENDORS
const VendorsListPage = lazy(() => import('src/pages/dashboard/vendors/list'));

// VENDORS
const CategoriesListPage = lazy(() => import('src/pages/dashboard/categories/list'));

// LOBBY BLOCKS
const LobbyBlocksListPage = lazy(() => import('src/pages/dashboard/lobby-blocks/list'));
const LobbyBlocksCreatePage = lazy(() => import('src/pages/dashboard/lobby-blocks/new'));
const LobbyBlocksEditPage = lazy(() => import('src/pages/dashboard/lobby-blocks/edit'));

// BONUS
const BonusProgramListPage = lazy(() => import('src/pages/dashboard/bonuses/bonus-program/list'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
        ],
      },
      {
        path: 'level',
        children: [
          { element: <LevelListPage />, index: true },
          { path: 'list', element: <LevelListPage /> },
          { path: 'new', element: <LevelCreatePage /> },
          { path: ':id/edit', element: <LevelEditPage /> },
        ],
      },
      {
        path: 'quest',
        children: [
          { element: <QuestListPage />, index: true },
          { path: 'list', element: <QuestListPage /> },
          { path: 'new', element: <QuestCreatePage /> },
          { path: ':id/edit', element: <QuestEditPage /> },
        ],
      },
      {
        path: 'games',
        children: [
          { element: <GamesListPage />, index: true },
          { path: 'list', element: <GamesListPage /> },
          { path: 'new', element: <GamesCreatePage /> },
          { path: ':id/edit', element: <GamesEditPage /> },
        ],
      },
      {
        path: 'vendors',
        children: [
          { element: <VendorsListPage />, index: true },
          { path: 'list', element: <VendorsListPage /> },
        ],
      },
      {
        path: 'categories',
        children: [
          { element: <CategoriesListPage />, index: true },
          { path: 'list', element: <CategoriesListPage /> },
        ],
      },
      {
        path: 'lobby-blocks',
        children: [
          { element: <LobbyBlocksListPage />, index: true },
          { path: 'list', element: <LobbyBlocksListPage /> },
          { path: 'new', element: <LobbyBlocksCreatePage /> },
          { path: ':id/edit', element: <LobbyBlocksEditPage /> },
        ],
      },
      {
        path: 'bonus',
        children: [
          { element: <BonusProgramListPage />, index: true },
          { path: 'list', element: <BonusProgramListPage /> },
        ],
      },
    ],
  },
];
